import { useQuery } from "@tanstack/react-query";
import { LuFileCode, LuCircleCheck } from "react-icons/lu";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { PageHeader } from "@/components/ui/page-header";
import { SkeletonList } from "@/components/ui/skeleton";

/**
 * Read-only view of applied migrations on the product DB. Running new
 * migrations from the UI is intentionally NOT exposed here - too easy
 * to misclick. Use `pnpm db:migrate` from the CLI.
 */
export function MigrationsPage() {
  const list = useQuery({
    queryKey: ["console", "admin", "migrations"],
    queryFn: () => api.adminMigrations(),
  });
  return (
    <>
      <PageHeader
        icon={LuFileCode}
        title="Migrations"
        description="Schema migrations applied on the product database. Read-only - run new migrations via pnpm db:migrate."
      />
      <div className="p-8">
        {list.isLoading && <SkeletonList rows={6} />}
        {list.data && (
          <Card>
            <div className="divide-y divide-[var(--color-border)]">
              {list.data.applied.length === 0 && (
                <p className="px-5 py-6 text-sm text-[var(--color-text-muted)]">
                  No migrations recorded yet.
                </p>
              )}
              {list.data.applied.map((m) => (
                <div key={m.filename} className="px-5 py-3 flex items-center justify-between gap-3">
                  <div className="flex items-center gap-3 min-w-0">
                    <LuCircleCheck className="w-3.5 h-3.5 text-[#6ee7b7] shrink-0" />
                    <span className="font-mono text-sm text-[var(--color-text)] truncate">
                      {m.filename}
                    </span>
                  </div>
                  <span className="text-xs font-mono text-[var(--color-text-subtle)] tabular-nums shrink-0">
                    {new Date(m.applied_at).toLocaleString()}
                  </span>
                </div>
              ))}
            </div>
          </Card>
        )}
      </div>
    </>
  );
}
